// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2JKbf","title":"Images90_title__3dafI","images":"Images90_images__2BbN7"};